import { SYSTEM_USER_MANAGEMENT } from "api/ApiPath";
import client from "api/client";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import { ISystemUserRepository } from "features/systemUserManagement/domain/repositories/ISystemUserRepository";
import { injectable } from "tsyringe";
import { SystemUserFormRequestModel } from "./model/SystemUserFormRequestModel";
import { SystemUserResponseModel } from "./model/SystemUserResponseModel";

@injectable()
export class SystemUserImpl implements ISystemUserRepository {
  async getList(
    params: SystemUserFormRequestModel,
  ): Promise<ListBaseApiResponseModel<SystemUserResponseModel>> {
    return await client.get(SYSTEM_USER_MANAGEMENT.LIST, params);
  }

  async getDetail(
    code: string,
  ): Promise<BaseApiResponseModel<SystemUserResponseModel>> {
    return await client.get(SYSTEM_USER_MANAGEMENT.DETAIL, { code });
  }

  async create(
    body: SystemUserFormRequestModel,
  ): Promise<BaseApiResponseModel<SystemUserResponseModel>> {
    return await client.post(SYSTEM_USER_MANAGEMENT.CREATE, body);
  }

  async update(
    body: SystemUserFormRequestModel,
  ): Promise<BaseApiResponseModel<SystemUserResponseModel>> {
    return await client.put(SYSTEM_USER_MANAGEMENT.UPDATE, body);
  }

  async delete(
    code: string,
  ): Promise<BaseApiResponseModel<SystemUserResponseModel>> {
    return await client.delete(SYSTEM_USER_MANAGEMENT.DELETE, { code });
  }
}
